// extracted by mini-css-extract-plugin
export default {"bodyBackground":"styles_bodyBackground__GpTv+"};